<template>
<!-- eslint-disable vue/valid-v-slot -->
<v-content class="ma-1 py-1 px-0 black--text">
      <v-flex xs12 class="left-side">
         <p class="subtitle-2 mb-1">{{$t('Feeds')}} </p>
			<v-data-table
				:headers="tmrHeaders"
				:items="tmr.feeds"
				class="table-border"
				item-key="id"
				disable-pagination
				fixed-header
				disable-sort
				hide-default-footer
            :no-data-text="this.$i18n.t('No Data Available')"
				light
				>
            <template v-slot:item.tolerance="{ item }">
					<span class="align=center">{{Math.round(item.tolerance)}}</span>
				</template>
            <template v-slot:item.qty="{ item }">
					<span class="align=center">{{Math.round(item.qty * wgnDoses)}}</span>
				</template>
            <template v-slot:item.endsWeight="{ item }">
					<span class="align=center">{{Math.round(runningBalance(item))}}</span>
				</template>
				<template v-slot:item.manLoad="{ item }">
					<span v-if="item.manLoad">&#10004;</span>
            <!-- <v-icon  small color="orange darken-1" class="mx-2">mdi-hand-right</v-icon> -->
				</template>
				<template v-slot:item.index="{ item }">
					<span class="align-center">{{tmr.feeds.indexOf(item)+1}}</span>
				</template>
			</v-data-table>
        <p class="subtitle-2 mt-1">
           {{$t('Total') }}: {{Math.round(wgnTotal) | kgString}} {{$t('Dose Weight')}}: {{doseWeight | kgString}}
         </p>
      </v-flex>
</v-content>
</template>

<script>
export default {
   name: "PrintWagonSection",
   props: ["wgn", "tmr", "first", "print"],
   data() {
       return {
         tmrHeaders: [
         { text: "#", align: "left", value: "index" },
         { text: this.$i18n.t('Code'), align: "left", value: "code" },
         { text: this.$i18n.t('Name'), width: "30%", value: "name" },
         { text: this.$i18n.t('Qty_Kg'), align: "right", value: "qty" },
         { text: this.$i18n.t('End Weight'), align: "right", value: "endsWeight" },
         { text: this.$i18n.t('Toler_Kg'), align: "right", value: "tolerance" },
         { text: this.$i18n.t('Man Load'), align: "right", value: "manLoad" }
         ]
      };
   },
   methods: {
      runningBalance(item) {
         const index = this.tmr.feeds.indexOf(item);
         return this.tmr.feeds.reduce((p, c, i) => i <= index ? p + Number(c.qty) * this.wgnDoses : p, 0);
      },
   },
   computed: {
      wgnTotal() {
         return this.wgn.groups.reduce(function (a, g) {
            return isNaN(Number(g['qty'])) ? a : a + Number(g["qty"]);
            }, 0);
      },
      wgnDoses() {
         let deliverQty = this.wgnTotal;
         return  deliverQty / this.doseWeight;
      },
      doseWeight() {
         return  this.tmr.feeds.reduce(function (a, f) {
            return isNaN(Number(f["qty"])) ? a : a + Number(f["qty"]);
                }, 0);
      }
   },
}
</script>

<style scoped>
   .table-border{
      border:1px solid #424242;
   }

   /* @media print { */
      .left-side {
         max-width: 12cm;      /* A4	= 595 x 842 (72ppi)    794 x 1123 (96ppi)*/
      }
   /* } */
</style>